import { getForumUid } from '@/utils/forum/forumUid';

/**
 * 论坛 keep-alive 页面登录/绑定成功后补拉数据。
 * 子页面通过 getForumLoginRefreshConfig 返回 { routeName, when, onRefresh }。
 */
export default {
  data() {
    return {
      forumLoginRefreshing: false,
    };
  },
  created() {
    this._forumLoginTickUnwatch = this.$watch(
      () => this.$store.state.account.loginTick,
      (tick, prevTick) => {
        if (tick <= 0 || tick === prevTick) return;
        this.runForumLoginRefresh();
      },
    );
  },
  beforeDestroy() {
    if (this._forumLoginTickUnwatch) {
      this._forumLoginTickUnwatch();
      this._forumLoginTickUnwatch = null;
    }
  },
  methods: {
    getForumLoginRefreshConfig() {
      return null;
    },
    runForumLoginRefresh() {
      const config = this.getForumLoginRefreshConfig();
      if (!config || typeof config.onRefresh !== 'function') return;
      if (!getForumUid()) return;
      if (config.routeName) {
        const names = Array.isArray(config.routeName) ? config.routeName : [config.routeName];
        if (!names.includes(this.$route.name)) return;
      }
      if (config.when && !config.when.call(this)) return;
      if (this.forumLoginRefreshing) return;
      this.forumLoginRefreshing = true;
      Promise.resolve(config.onRefresh.call(this))
        .catch(() => {
          // 接口失败提示由页面/axios 统一处理
        })
        .finally(() => {
          this.forumLoginRefreshing = false;
        });
    },
  },
};
